import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import store from './store/store'
import ActivityMonitor from './plugins/ActivityMonitor'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import VueCurrencyInput from 'vue-currency-input'
Vue.config.productionTip = false

const pluginOptions = {
  /* see config reference */
  globalOptions: { currency: 'USD' , locale: 'en', precision: 2,allowNegative: false}
}

Vue.use(ActivityMonitor, {
  events: ['keydown', 'mousedown'],
  inactivityTimeout:
    (process.env.VUE_APP_ACTIVITY_TIMEOUT_MINUTES -
      process.env.VUE_APP_ACTIVITY_TIMEOUT_WARNING_MINUTES) *
    60000,
  throttlerTimeout: 1000,
  onInactiveUser: () => {
    store.dispatch('beginFinalInactivityTimer')
  }
})
Vue.use(require('vue-moment')) // Adds MomentJS date handling utilities
Vue.use(VueCurrencyInput, pluginOptions)
new Vue({
  render: h => h(App),
  router,
  vuetify,
  store,
}).$mount('#app')
